export function initToggles() {
  const isPresent = document.querySelector("[data-toggle-element]");
  if (!isPresent) {
    return;
  }

  const toggles = document.querySelectorAll("[data-toggle-element]");
  const targets = document.querySelectorAll("[data-toggle-target]");
  const closeBtns = document.querySelectorAll("[data-toggle-close]");

  function clearActives() {
    toggles.forEach((el) => {
      el.classList.remove("active");
    });
  }

  function clearWindows() {
    targets.forEach((el) => {
      el.classList.remove("is-visible");
    });
  }

  toggles.forEach((el) => {
    el.addEventListener("click", function () {
      clearActives();

      el.classList.toggle("active");

      document.body.classList.add("menu-open");

      const target = document.querySelector(
        `[data-toggle-target=${el.dataset.toggleElement}]`
      );

      if (target.classList.contains("is-visible")) {
        clearActives();
        target.classList.remove("is-visible");
      } else {
        clearWindows();
        target.classList.add("is-visible");
      }
    });
  });

  closeBtns.forEach((el) => {
    el.addEventListener("click", function () {
      clearWindows();
      clearActives();
      document.body.classList.remove("menu-open");
    });
  });

  function documentClick(e) {
    if (
      !e.target.closest("[data-toggle-element]") &&
      !e.target.closest("[data-toggle-target]")
    ) {
      clearWindows();
      clearActives();
      document.body.classList.remove("menu-open");
    }
  }

  toggles.forEach((toggle) => {
    if (toggle.classList.contains("active")) {
      document.addEventListener("click", documentClick);
    } else {
      document.addEventListener("click", documentClick);
    }
  });
}

export function toggleHubMenus() {
  const isPresent = document.querySelector("[data-toggle-sub]");
  if (!isPresent) {
    return;
  }
  // First, select all elements with the 'data-toggle-sub' attribute
  const toggleElements = document.querySelectorAll("[data-toggle-sub]");

  // Define the click event handler
  const toggleClasses = (event) => {
    // Prevent default action if needed
    // event.preventDefault();

    // The element that was clicked
    const toggleElement = event.currentTarget;

    // Toggle the 'active' class on the element itself
    toggleElement.classList.toggle("active");

    // Find the parent element of the clicked element
    const parentElement = toggleElement.parentElement;

    // From the parent, find the next sibling element with the 'data-target-sub' attribute
    const targetElement = parentElement.nextElementSibling;

    // console.log(parentElement.nextElementSibling);

    // Check if we have found the correct sibling and toggle the 'is-visible' class
    if (targetElement) {
      targetElement.classList.toggle("is-visible");
    }
  };

  // Attach the event handler to each toggle element
  toggleElements.forEach((toggleElement) => {
    toggleElement.addEventListener("click", toggleClasses);
  });
}
